module.exports = require('frontend/components/abstract').extend

  template: require('./index.pug')

  methods:

    submit: ->
      @.$refs.submitButton.click()

    onSubmit: ->
      @.$emit('submit')


// WEBPACK FOOTER //
// ./assets/js/frontend/components/prevented_form/index.coffee